module.exports = "/packs/media/images/growth3-8b37051d9f536871fcd453637bdb3a2f.jpg";